var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatisfeito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 871,
    height: 871,
    viewBox: "0 0 871 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_63652)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_63652",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 871,
    height: 871
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M870.858 0H0.00585938V870.852H870.858V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_63652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.744 436.587C767.744 619.333 619.599 767.478 436.852 767.478C254.106 767.478 105.959 619.333 105.959 436.587C105.959 253.84 254.106 105.693 436.852 105.693C619.599 105.693 767.744 253.84 767.744 436.587Z",
    fill: "url(#paint0_linear_14_63652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.884 437.834C729.332 604.316 595.216 737.25 432.327 734.754C269.438 732.258 139.459 595.276 142.012 428.794C144.564 262.312 278.68 129.377 441.569 131.873C604.457 134.37 734.437 271.352 731.884 437.834Z",
    fill: "url(#paint1_radial_14_63652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81 353.179C375.976 316.992 346.462 316.688 341.357 316.688C336.551 316.688 306.736 316.992 291.902 353.179C273.682 397.627 295.706 445.834 302.713 425.258C316.828 383.813 337.077 384.263 341.357 384.263C345.87 384.263 365.883 383.813 379.999 425.258C387.006 445.834 409.029 397.627 390.81 353.179Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81 372.449C375.976 336.262 346.462 335.959 341.357 335.959C336.551 335.959 306.736 336.262 291.902 372.449C273.682 416.897 295.706 465.104 302.713 444.528C316.828 403.083 337.077 403.534 341.357 403.534C345.87 403.534 365.883 403.083 379.999 444.528C387.006 465.104 409.029 416.897 390.81 372.449Z",
    fill: "#FFF293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.053 363.69C374.219 327.502 346.457 327.199 341.352 327.199C336.546 327.199 308.482 327.502 293.649 363.69C275.429 408.137 292.197 456.345 299.204 435.768C313.319 394.324 337.072 394.774 341.352 394.774C345.865 394.774 369.382 394.324 383.497 435.768C390.505 456.345 407.272 408.137 389.053 363.69Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.553 429.311C396.025 414.893 394.693 397.321 387.195 378.681C372.935 343.205 346.253 342.925 341.348 342.925C336.74 342.925 309.778 343.205 295.518 378.681C288.037 397.321 286.688 414.875 288.142 429.294C284.218 414.823 283.412 388.649 293.643 363.685C308.482 327.508 336.547 327.192 341.348 327.192C346.463 327.192 374.213 327.508 389.052 363.685C399.301 388.667 398.477 414.84 394.553 429.311Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.05 353.178C494.883 316.991 524.398 316.688 529.503 316.688C534.308 316.688 564.124 316.991 578.957 353.178C597.177 397.626 575.154 445.833 568.146 425.257C554.031 383.812 533.783 384.262 529.503 384.262C524.99 384.262 504.976 383.812 490.861 425.257C483.853 445.833 461.83 397.626 480.05 353.178Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.05 372.449C494.883 336.262 524.398 335.959 529.503 335.959C534.308 335.959 564.124 336.262 578.957 372.449C597.177 416.897 575.154 465.104 568.146 444.528C554.031 403.083 533.783 403.534 529.503 403.534C524.99 403.534 504.976 403.083 490.861 444.528C483.853 465.104 461.83 416.897 480.05 372.449Z",
    fill: "#FFF293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.807 363.69C496.64 327.502 524.403 327.199 529.508 327.199C534.313 327.199 562.377 327.502 577.21 363.69C595.43 408.137 578.663 456.345 571.655 435.768C557.54 394.324 533.788 394.774 529.508 394.774C524.995 394.774 501.477 394.324 487.362 435.768C480.354 456.345 463.587 408.137 481.807 363.69Z",
    fill: "#974700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.306 429.31C474.835 414.892 476.166 397.32 483.664 378.68C497.925 343.204 524.606 342.924 529.512 342.924C534.119 342.924 561.081 343.204 575.342 378.68C582.822 397.32 584.171 414.874 582.717 429.293C586.641 414.822 587.447 388.648 577.216 363.684C562.377 327.507 534.312 327.191 529.512 327.191C524.396 327.191 496.646 327.507 481.807 363.684C471.559 388.666 472.382 414.839 476.306 429.31Z",
    fill: "#622900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.857 514.709C237.031 510.211 201.365 452.652 201.365 495.36C201.365 614.652 304.857 713.493 436.857 713.493C568.856 713.493 672.348 614.652 672.348 495.36C672.348 452.652 636.683 510.211 436.857 514.709Z",
    fill: "#FDDD78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.348 483.003C672.348 594.477 564.961 688.362 436.857 688.362C308.752 688.362 201.365 594.477 201.365 483.003C201.365 481.899 201.402 480.883 201.455 479.92C203.583 446.195 248.266 498.525 436.857 502.607C625.448 498.525 670.13 446.195 672.259 479.92C672.311 480.883 672.348 481.899 672.348 483.003Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.436 495.267C669.436 606.741 563.376 700.625 436.853 700.625C310.33 700.625 204.27 606.741 204.27 495.267C204.27 494.163 204.305 493.147 204.357 492.183C206.459 458.459 250.59 510.789 436.853 514.871C623.116 510.789 667.246 458.459 669.348 492.183C669.401 493.147 669.436 494.163 669.436 495.267Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.41 619.88C638.139 589.975 648.353 555.567 648.353 519.303C648.353 518.199 648.335 517.183 648.283 516.219C646.373 482.495 606.237 534.825 436.845 538.907C267.471 534.825 227.334 482.495 225.425 516.219C225.372 517.183 225.337 518.199 225.337 519.303C225.337 555.585 235.568 590.01 253.333 619.932C222.692 585.122 204.262 541.71 204.262 495.267C204.262 494.163 204.297 493.147 204.349 492.183C206.452 458.459 250.582 510.789 436.845 514.871C623.108 510.789 667.238 458.459 669.341 492.183C669.393 493.147 669.428 494.163 669.428 495.267C669.428 541.692 651.016 585.069 620.41 619.88Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.31 624.231C518.844 624.231 579.425 608.464 614.481 596.019C591.49 656.541 504.233 699.178 439.307 699.178C368.162 699.178 285.758 660.37 260.438 596.88C295.178 609.2 354.568 624.231 437.31 624.231Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88 615.868C518.414 615.868 578.995 602.729 614.051 592.357C573.389 642.882 503.803 678.324 438.878 678.324C367.733 678.324 299.583 642.812 260.008 593.076C294.748 603.342 354.138 615.868 436.88 615.868Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.361 594.828C598.529 596.685 590.926 598.577 582.569 600.416V600.504L582.587 601.152C582.587 601.152 535.939 677.127 437.038 677.127C338.323 677.127 291.49 601.152 291.49 601.152V601.134C279.401 598.472 268.89 595.704 260.008 593.076C299.233 642.374 366.559 677.71 437.038 678.306C437.056 678.306 437.056 678.306 437.073 678.306C437.669 678.324 438.282 678.324 438.878 678.324C503.803 678.324 573.389 642.882 614.051 592.357C611.3 593.163 608.41 593.987 605.361 594.828Z",
    fill: "#C7D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.688 519.15C647.059 537.007 642.311 542.703 635.076 560.175C626.94 575.992 548.917 608.578 438.88 608.578C327.809 608.578 246.275 576.443 239.267 560.91C231.664 542.433 226.846 535.937 225.375 517.309C225.287 516.28 225.41 515.338 225.445 514.439C227.319 483.201 273.027 538.805 438.88 542.594C604.75 538.805 646.743 485.042 648.618 516.28C648.653 517.179 648.776 518.122 648.688 519.15Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.688 516.569C647.059 531.18 642.311 545.879 635.076 560.174C618.222 566.849 546.92 592.199 436.883 592.199C325.812 592.199 257.855 568.373 239.267 560.91C231.664 545.791 226.846 530.304 225.375 515.063C225.287 514.222 225.41 513.451 225.445 512.715C227.319 487.155 273.027 532.652 438.88 535.753C604.75 532.652 646.743 488.661 648.618 514.222C648.653 514.958 648.776 515.728 648.688 516.569Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.688 516.569C647.059 531.18 642.311 545.879 635.076 560.174C630.579 561.956 622.201 565.066 610.246 568.671C640.186 519.395 610.411 528.374 488.441 537.238C470.563 538.538 452.776 539.423 436.798 539.423C412.603 539.423 381.682 536.538 352.451 534.341C267.256 527.936 236.152 520.271 269.984 571.196C255.248 567.003 244.951 563.193 239.267 560.91C231.664 545.791 226.846 530.304 225.375 515.063C225.287 514.222 225.41 513.451 225.445 512.715C227.319 487.155 273.027 532.652 438.88 535.753C604.75 532.652 646.743 488.661 648.618 514.222C648.653 514.958 648.776 515.728 648.688 516.569Z",
    fill: "#C7D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.744 436.587C767.744 619.333 619.599 767.478 436.852 767.478C254.106 767.478 105.959 619.333 105.959 436.587C105.959 253.84 254.106 105.693 436.852 105.693C619.599 105.693 767.744 253.84 767.744 436.587Z",
    stroke: "#E66900",
    strokeWidth: 10.2512,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_63652",
    x1: 435.358,
    y1: 134.602,
    x2: 435.358,
    y2: 756.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5AB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ED8700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14_63652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(426.597 160.477) scale(581.483 581.483)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FEFEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDEE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCDE36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F5B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE910A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_63652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 870.852,
    height: 870.852,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfeito);
export default __webpack_public_path__ + "static/media/satisfeito.6f4005f494b012e442df15eac6e903cf.svg";
export { ForwardRef as ReactComponent };